import ProviderAPI from "../redux/ProviderAPI";


export const getYachtTypes = async (data, token) => {
    const result = await ProviderAPI({
      type: "GET",
      url: "yachtTypes/detailYachtTypes",
      data,
      token,
    });
     
    return result;
  };
    